export function getStage(): string {
  const validStages = ['beta', 'gamma', 'prod', 'test'];
  // Katal replaces the key
  const replacedStage = '{{Stage}}'.toLowerCase();
  if (validStages.includes(replacedStage)) {
    // Local testing will default to beta
    // @ts-ignore
    if (replacedStage === 'test') return 'beta';
    return replacedStage;
  }

  // If {{Stage}} wasn't replaced, try to get the stage from the env.js file
  if (typeof window !== 'undefined' && window.env && window.env.STAGE) {
    return window.env.STAGE;
  }

  // If neither is available, return a default value
  return 'default';
}

export function getURL(): string {
  const url = window.location.toString();
  // This is for MOC
  if (url.includes('amazonoperations')) {
    const urlObj = new URL(url);
    return`${urlObj.origin}/`;
  }
  // This is for CORP
  return 'https://{{Stage}}.pak.qubit.amazon.dev/';
}

export function isAftxURL(): boolean {
  const url = window.location.toString();
  return url.includes('amazonoperations');
}
